import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS } from "../../utils/apiPaths";
import { LuTrash2 } from "react-icons/lu";
import { GrUpdate } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import ProjectGrid from "../../components/Cards/ProjectGrid";
const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axiosInstance.get(
        API_PATHS.PROJECT.GET_ALL_PROJECT
      );
      const data = response.data || [];
      setProjects(data);
    } catch (error) {
      console.error("Erreur fetchProjects:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer ce projet ?")) {
      await axiosInstance.delete(API_PATHS.PROJECT.DELETE_PROJECT(id));
      setProjects(projects.filter((p) => p._id !== id));
    }
  };

  const handleClick = (project_id) => {
    navigate("/admin/project", { state: { projectId: project_id } });
  };
  if (loading) return <p>Chargement...</p>;

  return (
    <DashboardLayout>
      <h1>Projets</h1>
      <div className="form-card col-span-3">
        <ul>
          {projects.map((project) => (
            <li key={project._id}>
              <ProjectGrid projects={[project]} />
              <div className="flex items-center justify-center gap-3 mt-2">
                <button
                  className="flex items-center gap-1.5 text-[13px] font-medium text-rose-500 bg-rose rounded px-2 py-1 border border-rose-100 hover:border-rose-300 cursor-pointer"
                  onClick={() => handleDelete(project._id)}
                >
                  <LuTrash2 className="text-base" />
                  Supprimer
                </button>
                <button
                  className="flex items-center gap-1.5 text-[13px] font-medium text-blue-500 bg-rose rounded px-2 py-1 border border-rose-100 hover:border-blue-300 cursor-pointer"
                  onClick={() => handleClick(project._id)}
                >
                 <GrUpdate className="text-base" />
                  Modifier
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </DashboardLayout>
  );
};

export default ProjectList;
